import { Menu, createStyles } from '@mantine/core';
import { Icon, IconButton } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	button: {
		color: theme.other.getColor('text/primary/default'),
	},
}));

interface CreateAgentActionProps {
	onClick: () => void;
	/** Render as a button instead of a menu item */
	asButton?: boolean;
}

export function CreateAgentMenuItem({
	onClick,
	asButton = false,
}: CreateAgentActionProps) {
	const { classes } = useStyles();

	if (asButton) {
		return (
			<IconButton
				iconName="click"
				className={classes.button}
				onClick={onClick}
				variant="tertiary"
				tooltip="Create agent"
			/>
		);
	}

	return (
		<Menu.Item icon={<Icon name="click" />} onClick={onClick}>
			Create agent...
		</Menu.Item>
	);
}
